"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92093,51906],{

/***/ 33603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getTransitionName; }
/* harmony export */ });
// ================== Collapse Motion ==================
var getCollapsedHeight = function getCollapsedHeight() {
  return {
    height: 0,
    opacity: 0
  };
};

var getRealHeight = function getRealHeight(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};

var getCurrentHeight = function getCurrentHeight(node) {
  return {
    height: node.offsetHeight
  };
};

var skipOpacityTransition = function skipOpacityTransition(_, event) {
  return event.propertyName === 'height';
};

var collapseMotion = {
  motionName: 'ant-motion-collapse',
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
};

var getTransitionName = function getTransitionName(rootPrefixCls, motion, transitionName) {
  if (transitionName !== undefined) {
    return transitionName;
  }

  return "".concat(rootPrefixCls, "-").concat(motion);
};


/* harmony default export */ __webpack_exports__["Z"] = (collapseMotion);

/***/ }),

/***/ 31808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fk": function() { return /* binding */ detectFlexGapSupported; },
/* harmony export */   "jD": function() { return /* binding */ canUseDocElement; }
/* harmony export */ });
/* unused harmony export isStyleSupport */
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98924);

var canUseDocElement = function canUseDocElement() {
  return (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported() {
  if (!canUseDocElement()) {
    return false;
  }

  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  document.body.removeChild(flex);
  return flexGapSupported;
};

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};



/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 51906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModalErrorManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/MainLayout/store.ts
var MainLayout_store = __webpack_require__(73580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/MainLayout/ModalErrorMessage/constants.ts
var constants = __webpack_require__(5728);
;// CONCATENATED MODULE: ./src/global/MainLayout/ModalErrorMessage/index.tsx














var ModalError = function(param) {
    var _dataCy = param.dataCy, dataCy = _dataCy === void 0 ? "" : _dataCy, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 1000 : _zIndex, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? 0 : _errorCode, _errorType = param.errorType, errorType = _errorType === void 0 ? "" : _errorType, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _isErrorSecurities = param.isErrorSecurities, isErrorSecurities = _isErrorSecurities === void 0 ? true : _isErrorSecurities, _onLogout = param.onLogout, onLogout = _onLogout === void 0 ? function() {} : _onLogout, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisible = ref[1];
    // access trading modal store
    var closeTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var isTradingModalVisible = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.visible;
    });
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useMemo)(function() {
        var ref;
        if (!isErrorSecurities) {
            return constants/* errorInfoList.find */.qO.find(function(param) {
                var error = param.error;
                return error === errorCode;
            }) || {};
        }
        var modalConfigKey = (ref = constants/* tradingErrorModalList */.Ar[errorCode]) === null || ref === void 0 ? void 0 : ref[errorType || "NO_SERVER_RESPONSE"];
        return constants/* tradingErrorModalConfig */.c0[modalConfigKey] || {};
    }, [
        errorCode,
        errorType
    ]), modalErrorTitle = ref1.title, imageUrl = ref1.imageUrl, description = ref1.description, isShowButton = ref1.isShowButton, isLogoutUser = ref1.isLogoutUser, buttonText = ref1.buttonText, redirectTo = ref1.redirectTo, needToCloseTradingModal = ref1.needToCloseTradingModal, isFullWidthButton = ref1.isFullWidthButton;
    var handleModalCancel = function() {
        setVisible(false);
        onClose();
        if (isLogoutUser) onLogout();
    };
    var handleConfirmClick = function() {
        if (isLogoutUser) {
            onLogout();
        }
        if (redirectTo) {
            router.push((0,general/* sanitizeURL */.lz)(redirectTo));
        }
        setVisible(false);
        onClose();
    };
    var handleShowModal = (0,react.useCallback)(function() {
        if (!errorCode) return;
        // Show error modal if there is any modal error constant
        if (modalErrorTitle) {
            setVisible(true);
            return;
        }
        // Show error toast if there is no modal error constant
        // Specific case, due to existing issue on code that isShowAlertMessage not developed properly
        // We cannot handle isShowAlertMessage, because the requestConfigTrading is used widely
        // need to reconfirm to all api that use requestConfigTrading
        var isHideAlert = errorType !== "INVALID_CREDS" && router.asPath.includes("securities/withdrawal");
        if (!modalErrorTitle && errorMessage && isErrorSecurities && isHideAlert) {
            (0,AlertMessage/* default */.Z)({
                content: errorMessage,
                alertType: "plain-default",
                messageType: "error",
                hasCloseIcon: false,
                onCloseHandler: onClose
            });
        }
    }, [
        errorCode,
        errorType,
        errorMessage,
        modalErrorTitle
    ]);
    (0,react.useEffect)(function() {
        handleShowModal();
        if (needToCloseTradingModal && isTradingModalVisible) {
            closeTradingModal();
        }
    }, [
        handleShowModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        centered: true,
        className: dataCy,
        visible: isVisible,
        onCancel: handleModalCancel,
        afterClose: onClose,
        width: "400px",
        zIndex: zIndex,
        style: {
            borderRadius: "4px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            align: "center",
            justify: "center",
            padding: "50px 40px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "".concat(imageUrl),
                    alt: "info",
                    width: 140
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "error-trading-modal-title",
                    size: "1.2rem",
                    // @ts-expect-error
                    mt: "16px",
                    family: "bold",
                    muted: true,
                    children: modalErrorTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "1rem",
                    align: "center",
                    mt: "10px",
                    color: color/* default.dimgray */.Z.dimgray,
                    children: description || errorMessage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isShowButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        height: "46px",
                        type: "primary",
                        // @ts-expect-error
                        mt: "20px",
                        onClick: handleConfirmClick,
                        style: {
                            borderRadius: 4
                        },
                        width: isFullWidthButton ? "100%" : "auto",
                        children: buttonText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ModalErrorMessage = (ModalError);

;// CONCATENATED MODULE: ./src/global/MainLayout/ModalErrorMessage/ModalErrorManager.tsx













var useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
var useMainLayoutStore = (0,esm/* default */.ZP)(MainLayout_store/* default */.Z);
function ModalErrorManager() {
    var router = (0,next_router.useRouter)();
    var resetTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var resetOrderTable = (0,store/* default */.Z)(function(s) {
        return s.resetOrderTableStore;
    });
    var ref = useTradingStore(function(s) {
        return {
            errorCodeSecurities: s.errorCode,
            errorTypeSecurities: s.errorType,
            errorMessageSecurities: s.errorMessage,
            resetErrorCodeSecurities: s.resetErrorCode
        };
    }, shallow/* default */.Z), errorCodeSecurities = ref.errorCodeSecurities, errorTypeSecurities = ref.errorTypeSecurities, errorMessageSecurities = ref.errorMessageSecurities, resetErrorCodeSecurities = ref.resetErrorCodeSecurities;
    var ref1 = useMainLayoutStore(function(s) {
        return {
            errorCodeSocial: s.errorCode,
            errorTypeSocial: s.errorType,
            errorMessageSocial: s.errorMessage,
            resetErrorCodeSocial: s.resetErrorCode
        };
    }, shallow/* default */.Z), errorCodeSocial = ref1.errorCodeSocial, errorTypeSocial = ref1.errorTypeSocial, errorMessageSocial = ref1.errorMessageSocial, resetErrorCodeSocial = ref1.resetErrorCodeSocial;
    var currentPath = router === null || router === void 0 ? void 0 : router.asPath;
    var securitiesPathPattern = /securities\/.+/;
    var securitiesPath = securitiesPathPattern.test(currentPath);
    var handleLogoutSecurities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        resetOrderTable();
                        resetTradingModal();
                        useUIConfigStore/* default.getState */.Z.getState().setUIValue("featureFlags", {});
                        if (securitiesPath) router.push("/stream");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogoutSecurities() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLogoutSocial = function() {
        router.push("/logout");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorMessage, {
                dataCy: "modal-error-trading",
                zIndex: 1002,
                errorCode: errorCodeSecurities,
                errorType: errorTypeSecurities,
                errorMessage: errorMessageSecurities,
                onLogout: handleLogoutSecurities,
                onClose: resetErrorCodeSecurities,
                isErrorSecurities: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorMessage, {
                dataCy: "modal-error-social",
                zIndex: 1001,
                errorCode: errorCodeSocial,
                errorType: errorTypeSocial,
                errorMessage: errorMessageSocial,
                onLogout: handleLogoutSocial,
                onClose: resetErrorCodeSocial,
                isErrorSecurities: false
            })
        ]
    });
};


/***/ }),

/***/ 5728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ tradingErrorModalList; },
/* harmony export */   "c0": function() { return /* binding */ tradingErrorModalConfig; },
/* harmony export */   "qO": function() { return /* binding */ errorInfoList; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var errorInfoList = [
    {
        error: 401,
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama",
        isLogoutUser: true
    },
    {
        error: 500,
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        isShowButton: true,
        buttonText: "Tutup"
    },
    {
        error: 503,
        imageUrl: "/img/maintenance-mode.svg",
        title: "Maintenance Sedang Berlangsung",
        description: "Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama"
    }, 
];
var tradingErrorModalConfig = {
    sessionExpired: {
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: true,
        isLogoutUser: true
    },
    maintenance: {
        imageUrl: "/img/maintenance-mode.svg",
        title: "Pemeliharaan Sedang Berlangsung",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    dailyMaintenance: {
        imageUrl: "/img/daily-maintenance.svg",
        title: "Persiapan Harian",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    systemError: {
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        buttonText: "Tutup",
        isShowButton: true
    },
    userSuspend: {
        imageUrl: "/img/trading-limit-user-suspended.svg",
        title: "Tidak Dapat Melakukan Transaksi",
        description: "Deposit atau jual saham untuk melakukan transaksi.",
        buttonText: "Deposit Sekarang",
        isShowButton: true,
        redirectTo: "/securities/deposit",
        needToCloseTradingModal: true,
        isFullWidthButton: true
    }
};
var tradingErrorModalList = {
    401: {
        NO_SERVER_RESPONSE: "sessionExpired",
        INVALID_AUTH: "sessionExpired",
        // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
        INVALID_TOKEN: "sessionExpired",
        INVALID_SESSION: "sessionExpired",
        MOCK_TRADING: "sessionExpired",
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance",
        UNAUTHORIZED: "sessionExpired"
    },
    403: {
        USER_SUSPEND: "userSuspend",
        USER_SUSPEND_BACK_OFFICE: "userSuspend"
    },
    503: {
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance"
    },
    500: {
        SYSTEM_ERROR: "systemError"
    }
};


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
function contains(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}

/***/ }),

/***/ 15105:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (KeyCode);

/***/ }),

/***/ 74204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollBarSize; }
/* harmony export */ });
/* unused harmony export getTargetScrollBarSize */
/* eslint-disable no-param-reassign */
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = '0';
    outerStyle.left = '0';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

function ensureSize(str) {
  var match = str.match(/^(.*)px$/);
  var value = Number(match === null || match === void 0 ? void 0 : match[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}

function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }

  var _getComputedStyle = getComputedStyle(target, '::-webkit-scrollbar'),
      width = _getComputedStyle.width,
      height = _getComputedStyle.height;

  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}

/***/ }),

/***/ 64217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pickAttrs; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */

var ariaPrefix = 'aria-';
var dataPrefix = 'data-';

function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */


function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;

  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }

  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if ( // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) || // Data
    mergedConfig.data && match(key, dataPrefix) || // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ }),

/***/ 60374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shallow; }
/* harmony export */ });
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}




/***/ })

}]);